import {observer} from "mobx-react";
import * as React from "react";
import {observable} from "mobx";
import {VendorWelcome} from "./VendorWelcome";
import {UIStateVendor} from "../data/UIStateVendor";

import './VendorApp.pcss';
import {VendorWaitingForSetup} from "./VendorWaitingForSetup";
import {VendorDashboard} from "./VendorDashboard";

@observer
export class VendorApp extends React.Component<any, {}> {
  @observable setupIncomplete = true;
  @observable loginErrorMessage = '';

  constructor(props) {
    super(props);
    UIStateVendor.loadSettings().then(()=>{}).catch(()=>{ });
    if(document.referrer && document.referrer!==document.location.href && -1===document.referrer.indexOf('vendor.html') && 0===document.location.href.indexOf(document.referrer)) {
      this.loginErrorMessage = 'Your account is for the WCEP Vendor system. Please bookmark this page.';
    }
  }

  render(){
    if(UIStateVendor.settings) {
      if(!UIStateVendor.isLoggedIn) {
        return <VendorWelcome loginErrorMessage={this.loginErrorMessage} />;
      } else {
        if(UIStateVendor.hasVendorBooths) {
          return <VendorDashboard />;
        } else {
          return <VendorWaitingForSetup />;
        }
      }
    } else {
      return null;
    }
  }

}
